import {
    SET_REPORT,
    CLEAR_REPORT,
    GET_REPORT_SUCCESS,
    GET_REPORT_FAILED,
} from '../actions/type';

const initialState = { data: null, status: 'idle' };

export default function reportReducer(state = initialState, action) {
    const { type, data } = action;

    switch (type) {
        case SET_REPORT:
            return {
                ...state,
                data,
            }
        case CLEAR_REPORT:
            return {
                ...state,
                data: null,
            }
        case GET_REPORT_SUCCESS:
            return {
                ...state,
                status: 'success',
            }
        case GET_REPORT_FAILED:
            return {
                ...state,
                error: data,
                status: 'failed',
            }

        default:
            return state;
    }
}